import { useNavigate } from 'react-router';
import { useTranslation } from '@/locales';

import { BACK_BUTTON_STYLES } from '@/layouts/MainLayout/utils/constants';
import { useBreakpointsCtx } from '@/providers/BreakpointsProvider/BreakpointsContext.hooks';
import Tooltip from '@/components/atoms/Tooltip/Tooltip';
import { StyledInfoIcon } from '@/components/StyledSharedComponents/StyledIcons';
import { StyledAgioH1 } from '@/components/StyledSharedComponents/StyledTypography';
import {
  StyledBackButton,
  StyledBackArrowIcon,
  StyledHeader,
  StyledTitleWithTooltipWrapper,
  StyledToolbarWrappingBackButton,
} from '@/layouts/MainLayout/components/HeaderWithNavigation/components/Headers/SharedHeaders.styled';
import { ERoutes } from '@/types/routes';

export const AlertingSettingsHeader = () => {
  const { t } = useTranslation('alerting');
  const { isDesktop } = useBreakpointsCtx();
  const navigate = useNavigate();

  return (
    <StyledHeader position="static" isDesktop={isDesktop}>
      <StyledToolbarWrappingBackButton>
        <StyledBackButton
          onClick={() => navigate(ERoutes.ALERTING)}
          skipTypography
          disableRipple
          blockHoverBehavior
          sx={BACK_BUTTON_STYLES}
        >
          <StyledBackArrowIcon />
        </StyledBackButton>

        <StyledTitleWithTooltipWrapper>
          <StyledAgioH1 noWrap color="customSecondary.primary.DEFAULT">
            {t('settings.header.title')}
          </StyledAgioH1>
          <Tooltip arrow title={t('settings.header.tooltip')}>
            <div>
              <StyledInfoIcon />
            </div>
          </Tooltip>
        </StyledTitleWithTooltipWrapper>
      </StyledToolbarWrappingBackButton>
    </StyledHeader>
  );
};
